import type { IView } from '@barba/core';
import selectSocialLink from '../components/select-social-link';
import formSender from '../components/form-sender';
import fileInput from '../components/file-input';

export default {
    namespace: 'contacts-page',

    beforeEnter({ next }) {
        selectSocialLink.init(next.container);
        formSender.init(next.container);
        fileInput.init(next.container);
    },

    afterLeave({ current }) {
        selectSocialLink.destroy(current.container);
        formSender.destroy(current.container);
        fileInput.destroy(current.container);
    },
} as IView;
